import * as React from 'react';
import { GiftsContainer } from './components/Gifts';
import { ServicesContainer } from './components/Services';

export const ModernListView = () => {
  return (
    <>
      <ServicesContainer />

      <GiftsContainer />
    </>
  );
};
